import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MapPin, CalendarClock, ArrowRight, Sparkles } from "lucide-react";
import { api } from "@/lib/api";

const imgSrc = (u) => (u ? (u.startsWith("http") ? u : `${process.env.REACT_APP_BACKEND_URL}${u}`) : "");
const money = (sym, amt) => `${sym || ""}${Number(amt || 0).toLocaleString()}`;
const when = (iso) => {
  try { return new Date(iso).toLocaleDateString(undefined, { weekday: "short", day: "numeric", month: "short" }); }
  catch { return ""; }
};

export default function ThisWeekNearYou() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    const fetchNear = (geo = "") => api.get(`/events/near/soon?days=14${geo}`)
      .then(({ data }) => setItems(data.items || [])).catch(() => {});
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (pos) => fetchNear(`&lat=${pos.coords.latitude.toFixed(4)}&lng=${pos.coords.longitude.toFixed(4)}`),
        () => fetchNear(""), { enableHighAccuracy: false, timeout: 8000, maximumAge: 600000 }
      );
    } else fetchNear("");
  }, []);

  if (items.length === 0) return null;

  return (
    <section className="max-w-6xl mx-auto px-4 sm:px-6 py-10" data-testid="this-week-near-you">
      <div className="flex items-end justify-between mb-4">
        <div>
          <div className="text-[11px] uppercase tracking-widest text-brand flex items-center gap-1"><Sparkles size={13} /> This week near you</div>
          <h2 className="font-serif text-2xl sm:text-3xl mt-1">Gatherings the community is hosting</h2>
        </div>
        <Link to="/events" className="text-sm text-brand hover:underline hidden sm:flex items-center gap-1">See all <ArrowRight size={14} /></Link>
      </div>

      <div className="flex gap-4 overflow-x-auto pb-3 -mx-1 px-1 snap-x" data-testid="near-scroll">
        {items.map((e) => (
          <Link key={e.id} to={`/e/${e.id}`} data-testid={`near-card-${e.id}`}
            className="snap-start shrink-0 w-64 rud-card rounded-2xl overflow-hidden hover:border-brand/60 transition-colors group">
            <div className="h-32 w-full overflow-hidden bg-white/5">
              {e.cover && <img src={imgSrc(e.cover)} alt={e.title} className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-500" />}
            </div>
            <div className="p-3">
              <div className="text-[10px] uppercase tracking-widest text-brand">{e.kind === "meal" ? "Community Meal" : e.type}</div>
              <div className="font-medium text-sm mt-0.5 line-clamp-1">{e.title}</div>
              <div className="text-[11px] text-sec mt-1 flex items-center gap-1"><CalendarClock size={11} /> {when(e.start_at)}</div>
              <div className="text-[11px] text-sec flex items-center gap-1">
                <MapPin size={11} /> {e.address || "Nearby"}
                {typeof e.distance_km === "number" && <span className="text-brand">· ~{e.distance_km} km</span>}
              </div>
              <div className="text-brand text-sm mt-1.5">{e.is_free ? "Free" : `${money(e.symbol, e.price_per_person)} / person`}</div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
